export default "__VITE_ASSET__DuhNPFgk__"